module.exports = __webpack_public_path__ + "img/car_sendai25.9172859c.jpg";